import { CustomerBill } from './services/customer-bill.service';
import { RentabilityReportComponent } from './reports/rentability-report/rentability-report.component';
import { DisplaySuajeComponent } from './suajes/display-suaje/display-suaje.component';
import { Pdf } from "./coms";
import { PdfSettingsKeys } from './globals';
import { Utils } from "./util";
import { RemissionId } from './services/remission.service';




export class PdfTemplates{
  
  static Reports = {  
      CustomerBillExpiration: (data: {[cName: string]: any[]}, sumData: {[cName: string]: any[]}) => { //Need to define object Structure.
        let pdf: Pdf = new Pdf({orientation: 'landscape', margins: 'l', pageSize: 'A4'});
        pdf.service.docDefinition.styles = <any>PdfSettingsKeys.styles.CustomerBillExpiration;

        let headerColumns = [
          {title: 'folio', span: 1, style: ['tableHeader'], rowStyle: ['firstItem'], columnWidth: 40},
          {title: 'fechas', span: 2, style: ['tableHeader'], rowStyle: [''], columnWidth: 60},
          {title: 'fechas2', span: 2, style: ['tableHeader'], rowStyle: [''], columnWidth: 60},
          {title: 'dias', span: 2, style: ['tableHeader'], rowStyle: [''], columnWidth: 40},
          {title: 'dias2', span: 1, style: ['tableHeader'], rowStyle: [''], columnWidth: 40},
          {title: 'vencido', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 70},
          {title: 'por_vencer', span: 4, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 70},
          {title: 'por_vencer2', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 70},
          {title: 'por_vencer3', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 70},
          {title: 'por_vencer4', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 70},
          {title: 'saldo_total', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 70}
        ];

        let headerData = [
          { 
          folio: "", 
          fechas: 'Doc', 
          fechas2: 'Vencido', 
          dias: "Vencido",
          dias2: "xVencer",
          vencido: "",
          por_vencer: "0 a 7", 
          por_vencer2: "8 a 14", 
          por_vencer3: "15 a 21", 
          por_vencer4: "> 22", 
          saldo_total: ""
         }
        ];

        let bodyData = [{
            folio: "2332", 
            fechas: '14/01/20', 
            fechas2: '21/03/20', 
            dias: "1",
            dias2: "3",
            vencido:"0.00", 
            por_vencer: "$234.00", 
            por_vencer2: "", 
            por_vencer3: "", 
            por_vencer4: "", 
            saldo_total: "$234.00"
           },
           { 
            folio: "3424", 
            fechas: '11/03/20', 
            fechas2: '23/03/20', 
            dias: "2",
            dias2: "4",
            vencido:"303.00", 
            por_vencer: "$3433.00", 
            por_vencer2: "", 
            por_vencer3: "", 
            por_vencer4: "", 
            saldo_total: "$434.00"
           }]
           


        pdf.touchAbs({x:40,y:40}).img('http://www.iocsa.com.mx/img/main/logo_iocsa_big.png', 150).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().h1(PdfSettingsKeys.headers.CustomerBillExpiration.title).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().h2("Fecha de Reporte: " + `${Utils.getDateWhitoutTime(Date.now())}`).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().table(headerData, headerColumns, true, true).then(([index, cell]) => pdf.add(index, cell));

        console.log(data);
        for(let cn in data){
          pdf.touchAbs().h3(cn).then(([index, cell]) => pdf.add(index, cell)); // Print Client Name
          pdf.touchAbs().table(data[cn], headerColumns, false, true).then(([index, cell]) => pdf.add(index, cell)); // Print Data Table
          pdf.touchAbs().table(sumData[cn], headerColumns, false, true).then(([index, cell]) => pdf.add(index, cell)); // Print Totals Sum Table
        }
        // pdf.touchAbs().span('this.loremText').then(([index, cell]) => pdf.add(index, cell));
        // pdf.touchAbs().column(['this.loremText','this.loremText'], '*', 20 ).then(([index, cell]) => pdf.add(index, cell));
        pdf.open();
      },
      SupplierBillExpiration: (data: {[cName: string]: any[]}, sumData: {[cName: string]: any[]}) => { //Need to define object Structure.
        let pdf: Pdf = new Pdf({orientation: 'landscape', margins: 'l', pageSize: 'A4'});
        pdf.service.docDefinition.styles = <any>PdfSettingsKeys.styles.CustomerBillExpiration;

        let headerColumns = [
          {title: 'folio', span: 1, style: ['tableHeader'], rowStyle: ['firstItem'], columnWidth: 40},
          {title: 'fechas', span: 2, style: ['tableHeader'], rowStyle: [''], columnWidth: 60},
          {title: 'fechas2', span: 2, style: ['tableHeader'], rowStyle: [''], columnWidth: 60},
          {title: 'dias', span: 2, style: ['tableHeader'], rowStyle: [''], columnWidth: 40},
          {title: 'dias2', span: 1, style: ['tableHeader'], rowStyle: [''], columnWidth: 40},
          {title: 'vencido', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 70},
          {title: 'por_vencer', span: 4, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 70},
          {title: 'por_vencer2', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 70},
          {title: 'por_vencer3', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 70},
          {title: 'por_vencer4', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 70},
          {title: 'saldo_total', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 70}
        ];

        let headerData = [
          { 
          folio: "", 
          fechas: 'Doc', 
          fechas2: 'Vencido', 
          dias: "Vencido",
          dias2: "xVencer",
          vencido: "",
          por_vencer: "0 a 7", 
          por_vencer2: "8 a 14", 
          por_vencer3: "15 a 21", 
          por_vencer4: "> 22", 
          saldo_total: ""
         }
        ];

        let bodyData = [{
            folio: "2332", 
            fechas: '14/01/20', 
            fechas2: '21/03/20', 
            dias: "1",
            dias2: "3",
            vencido:"0.00", 
            por_vencer: "$234.00", 
            por_vencer2: "", 
            por_vencer3: "", 
            por_vencer4: "", 
            saldo_total: "$234.00"
           }]

        pdf.touchAbs({x:40,y:40}).img('http://www.iocsa.com.mx/img/main/logo_iocsa_big.png', 150).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().h1(PdfSettingsKeys.headers.SupplierBillExpiration.title).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().h2("Fecha de Reporte: " + `${Utils.getDateWhitoutTime(Date.now())}`).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().table(headerData, headerColumns, true, true).then(([index, cell]) => pdf.add(index, cell));

        console.log(data);
        for(let cn in data){
          pdf.touchAbs().h3(cn).then(([index, cell]) => pdf.add(index, cell)); // Print Client Name
          pdf.touchAbs().table(data[cn], headerColumns, false, true).then(([index, cell]) => pdf.add(index, cell)); // Print Data Table
          pdf.touchAbs().table(sumData[cn], headerColumns, false, true).then(([index, cell]) => pdf.add(index, cell)); // Print Totals Sum Table
        }
        // pdf.touchAbs().span('this.loremText').then(([index, cell]) => pdf.add(index, cell));
        // pdf.touchAbs().column(['this.loremText','this.loremText'], '*', 20 ).then(([index, cell]) => pdf.add(index, cell));
        pdf.open();
      },
      DisplaySuajeRequest: (data: {[cName: string]: any[]}, sumData: {[cName: string]: any[]}) => {

        let headerColumns = [
          {title: 'checkboxes', span: 1, style: ['tableHeader'], rowStyle: ['checkBoxesCenter'], columnWidth: 40},
          {title: 'checkTitles', span: 1, style: ['tableHeader'], rowStyle: [''], columnWidth: 140},
        ];

         let bodyData = [{
          checkboxes: "X", 
          checkTitles: 'Suaje', 
         },{
          checkboxes: "X", 
          checkTitles: 'Nuevo', 
         },{
          checkboxes: "X", 
          checkTitles: 'Mantenimiento', 
         },{
          checkboxes: "X", 
          checkTitles: 'Corrección', 
         },{
          checkboxes: "X", 
          checkTitles: 'Guia', 
         },{
          checkboxes: "X", 
          checkTitles: 'Fisica', 
         },{
          checkboxes: "X", 
          checkTitles: 'Electrónica', 
         }]

         let headerColumns2 = [
          {title: 'medidas_Generales', span: 2, style: ['tableHeader'], rowStyle: ['rightContent'], columnWidth: 80},
          {title: 'values', span: 1, style: ['tableHeader'], rowStyle: ['checkBoxesCenter'], columnWidth: 100},
          
        ];

        let bodyData2 = [{
          medidas_Generales: "Largo:", 
          values: '23',
         },{
          medidas_Generales: "Ancho:", 
          values: '45',
         },{
          medidas_Generales: "Alto:", 
          values: '56',
         },{
          medidas_Generales: "Pegue:", 
          values: 'X',
         },{
          medidas_Generales: "Fondo:", 
          values: 'X',
         }]

         let headerColumns3 = [
          {title: 'formación', span: 3, style: ['tableHeader'], rowStyle: ['rightContent'], columnWidth: 20},
          {title: 'values', span: 1, style: ['tableHeader'], rowStyle: ['checkBoxesCenter'], columnWidth: 40},
          {title: 'arrow', span: 1, style: ['tableHeader'], rowStyle: ['checkBoxesCenter'], columnWidth: 12.5},
          {title: 'medianil', span: 3, style: ['tableHeader'], rowStyle: ['rightContent'], columnWidth: 20},
          {title: 'values2', span: 1, style: ['tableHeader'], rowStyle: ['checkBoxesCenter'], columnWidth: 40},
          {title: 'arrow2', span: 1, style: ['tableHeader'], rowStyle: ['checkBoxesCenter'], columnWidth: 12.5},
        ];

        let bodyData3 = [{
          formación: "V:", 
          values: '0',
          arrow: '->',
          medianil: 'V:',
          values2: '0 mm',
          arrow2: "->"
         },{
          formación: "H:", 
          values: '0',
          arrow: '<-',
          medianil: 'H:',
          values2: '0 mm', 
          arrow2: "<-"
         }]

         let headerColumns4 = [
          {title: 'medida_Pleca_a_Pleca', span: 3, style: ['tableHeader'], rowStyle: ['rightContent'], columnWidth: 80},
          {title: 'values', span: 1, style: ['tableHeader'], rowStyle: ['checkBoxesCenter'], columnWidth: 70},
          {title: 'arrow', span: 1, style: ['tableHeader'], rowStyle: ['checkBoxesCenter'], columnWidth: 20},
        ];

        let bodyData4 = [{
          medida_Pleca_a_Pleca: "Vertical:", 
          values: '0 cm',
          arrow: '<-',
         
         },{
          medida_Pleca_a_Pleca: "Horizontal:", 
          values: '0 cm',
          arrow: '<-',
         }]

         let headerColumns5 = [
          {title: 'medidas_Generales', span: 2, style: ['tableHeader'], rowStyle: ['rightContent'], columnWidth: 80},
          {title: 'values', span: 1, style: ['tableHeader'], rowStyle: ['checkBoxesCenter'], columnWidth: 100},
          
        ];

        let bodyData5 = [{
          medidas_Generales: "No. Suaje:", 
          values: 'SJ-XX-0000',
         },{
          medidas_Generales: "Cliente:", 
          values: 'X',
         },{
          medidas_Generales: "HTP:", 
          values: ' X',
         },{
          medidas_Generales: "Cartón:", 
          values: 'X',
         },{
          medidas_Generales: "Calibre:", 
          values: '0 pts.',
         }]

         let headerColumns6 = [
          {title: 'medidas_Generales', span: 2, style: ['tableHeader'], rowStyle: ['rightContent'], columnWidth: 120},
          {title: 'values', span: 1, style: ['tableHeader'], rowStyle: ['checkBoxesCenter'], columnWidth: 60},
          
        ];

        let bodyData6 = [{
          medidas_Generales: "Fecha:", 
          values: '00.X,00',
         },{
          medidas_Generales: "Proveedor:", 
          values: 'Quadra',
         }]

         let headerColumns7 = [
          {title: 'medidas_Generales', span: 2, style: ['tableHeader'], rowStyle: ['rightContent'], columnWidth: 120},
          {title: 'values', span: 1, style: ['tableHeader'], rowStyle: ['checkBoxesCenter'], columnWidth: 60},
          
        ];

        let bodyData7 = [{
          medidas_Generales: "Anexo:    HTP/Plano", 
          values: 'X',
         },{
          medidas_Generales: "Guia de Suaje", 
          values: ' ',
         },{
         medidas_Generales: "Suaje", 
         values: 'X',
        }]

        let headerColumns8 = [
          {title: 'observaciones', span: 1, style: ['tableHeader'], rowStyle: ['checkBoxesCenter'], columnWidth: 380}
        ];

        let bodyData8 = [{
          observaciones: "Por favor agregar a factura: PRD-00-00-0000 - Gracias.", 
          
         }]

        let pdf: Pdf = new Pdf({orientation: 'landscape', margins: 'l', pageSize: 'A4'}); 
        pdf.service.docDefinition.styles = <any>PdfSettingsKeys.styles.DisplaySuaje;

        pdf.touchAbs({x:40,y:40}).img('http://www.iocsa.com.mx/img/main/logo_iocsa_big.png', 180).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs({x:40,y:60}).h1("Solicitud de Suaje").then(([index, cell]) => pdf.add(index, cell));
        // pdf.touchAbs({}).h2("Solicitud de Suaje2").then(([index, cell]) => pdf.add(index, cell));
        // pdf.touchAbs({}).column(['this.loremText','this.loremText'], '*', 20 ).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().table(bodyData, headerColumns, false, false).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().table(bodyData2, headerColumns2, true, false).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().table(bodyData3, headerColumns3, true, false).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().table(bodyData4, headerColumns4, true, false).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs({x:240,y:110}).table(bodyData5, headerColumns5, false, false).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs({x:240,y:220}).table(bodyData6, headerColumns6, false, false).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs({x:240,y:275}).table(bodyData7, headerColumns7, false, false).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs({x:440,y:110}).table(bodyData8, headerColumns8, true, false).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs({x:440,y:475}).h3("Roberto Jaramillo").then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs({x:410,y:480}).h3("Solicita: _______________________________________").then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs({x:410,y:510}).h3("NOTA: la posicion de suaje se considera viendo la ceja de pegue en posicion vertical. En base a esta se definen primero la cantidad de filas (F) y en segundo la cantidad de columnas (C) FxC").then(([index, cell]) => pdf.add(index, cell));
        
        
        
        console.log("running"); 


        pdf.open();
      },


      RentabilityReport: (data: {}, sumsData: {}, dateFilters: string, prorrateo: string) => { //Need to define object Structure.
        let pdf: Pdf = new Pdf({orientation: 'landscape', margins: 'l', pageSize: 'LEGAL'});
        pdf.service.docDefinition.styles = <any>PdfSettingsKeys.styles.RentabilityReport;

        let headerColumns = [
          {title: 'fecha', span: 1, style: ['tableHeader'], rowStyle: ['firstItem'], columnWidth: 50},
          {title: 'proyecto', span: 1, style: ['tableHeader'], rowStyle: [''], columnWidth: 90},
          {title: 'descripción_Corta', span: 1, style: ['tableHeader'], rowStyle: [''], columnWidth:90},
          {title: 'estatus', span: 1, style: ['tableHeader'], rowStyle: [''], columnWidth: 60},
          {title: 'pje_Producto', span: 1, style: ['tableHeader'], rowStyle: [''], columnWidth: 50},
          {title: 'precio_Unitario', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 55},
          {title: 'ventas_Piezas', span: 1, style: ['tableHeader'], rowStyle: [''], columnWidth: 55},
          {title: 'ventas', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 60},
          {title: 'notas_de_credito', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth:60},
          // {title: 'gastos', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 60},
          {title: 'principal', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 60},
          {title: 'segundo', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 60},
          {title: 'tercero', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth:60},
          {title: 'otros', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth:60},
          
          
          
        ];
        
        let secondHeaderColumns = [
          
          {title: 'proyecto', span: 1, style: ['tableHeader'], rowStyle: [''], columnWidth: 90},
          {title: 'mdO', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 80},
          {title: 'gastos', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 80},
          // {title: 'ventas', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 80},
          {title: 'gastos_venta', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 80},
          {title: 'gastos_administración', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 80},
          {title: 'gastos_producción', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 80},
          {title: 'gastos_dirección', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 80},
          {title: 'otros_gastos', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 80},
          {title: 'pje', span: 1, style: ['tableHeader'], rowStyle: [''], columnWidth: 80},
          {title: 'utilidad_bruta', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 105},
          // {title: 'segundo', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 60},
          // {title: 'tercero', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth:60},
          // {title: 'mdO', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 60},
        
        ];
        // let headerColumns = [
        //   {title: 'fecha', span: 1, style: ['tableHeader'], rowStyle: ['firstItem'], columnWidth: 50},
        //   {title: 'proyecto', span: 1, style: ['tableHeader'], rowStyle: [''], columnWidth: 90},
        //   {title: 'descripcion_Corta', span: 1, style: ['tableHeader'], rowStyle: [''], columnWidth:90},
        //   {title: 'estatus', span: 1, style: ['tableHeader'], rowStyle: [''], columnWidth: 60},
        //   {title: 'ventas', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 60},
        //   {title: 'principal', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 60},
        //   {title: 'segundo', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 60},
        //   {title: 'tercero', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth:60},
        //   {title: 'otros', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth:60},
        //   {title: 'gastos', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 60},
        //   {title: 'mdO', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 60},
        //   {title: 'rentabilidad', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 65},
        //   {title: 'pje', span: 1, style: ['tableHeader'], rowStyle: [''], columnWidth: 40}
        
        // ];

        let headerData = [
          { 
          folio: "", 
          fechas: 'Doc', 
          fechas2: 'Vencido', 
          dias: "Vencido",
          dias2: "xVencer",
          vencido: "",
          por_vencer: "0 a 7", 
          por_vencer2: "8 a 14", 
          por_vencer3: "15 a 21", 
          por_vencer4: "> 22", 
          saldo_total: ""
         }
        ];

        let bodyData = [{
            fecha: "2332", 
            proyecto: '14/01/20', 
            descripcion_Corta: 'Midnight City', 
            estatus: "1",
            ventas: "3",
            principal:"0.00", 
            segundo: "$234.00", 
            tercero: "", 
            otros: "", 
            gastos: "", 
            mdO: "$234.00",
            rentabilidad: "100%",
            '%': "ok"
           },
           { 
            fecha: "2332", 
            proyecto: '14/01/20', 
            descripcion_Corta: 'Esta es una descripcion', 
            estatus: "Terminado",
            ventas: "3",
            principal:"0.00", 
            segundo: "$234.00", 
            tercero: "", 
            otros: "", 
            gastos: "", 
            mdO: "$234.00",
            rentabilidad: "100%",
            '%': "100%"
           }]
           

        // console.log(data);
          
        pdf.touchAbs({x:40,y:40}).img('http://www.iocsa.com.mx/img/main/logo_iocsa_big.png', 150).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().h1(PdfSettingsKeys.headers.RentabilityReport.title + ' 1/2').then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().h2(dateFilters).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().table(data, headerColumns, true, true).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().table(sumsData, headerColumns, false, true).then(([index, cell]) => pdf.add(index, cell));
        (<any>pdf.touchAbs()).pageBreak('before').then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().h1(PdfSettingsKeys.headers.RentabilityReport.title + ' 2/2').then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().h2(dateFilters).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().table(data, secondHeaderColumns, true, true).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().table(sumsData, secondHeaderColumns, false, true).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().h3(`*Gastos prorrateados por ${(prorrateo)}.`).then(([index, cell]) => pdf.add(index, cell));
        
        // console.log(data);
        
          // pdf.touchAbs().h3(cn).then(([index, cell]) => pdf.add(index, cell)); // Print Client Name
          // pdf.touchAbs().table(bodyData, headerColumns, false, true).then(([index, cell]) => pdf.add(index, cell)); // Print Data Table
          // pdf.touchAbs().table(sumData[cn], headerColumns, false, true).then(([index, cell]) => pdf.add(index, cell)); // Print Totals Sum Table
        


        // pdf.touchAbs().span('this.loremText').then(([index, cell]) => pdf.add(index, cell));
        // pdf.touchAbs().column(['this.loremText','this.loremText'], '*', 20 ).then(([index, cell]) => pdf.add(index, cell));

        pdf.open();
      },

      CustomerBillsReport: (data: {}) => { //Need to define object Structure.
        let pdf: Pdf = new Pdf({orientation: 'landscape', margins: 'l', pageSize: 'A4'});
        pdf.service.docDefinition.styles = <any>PdfSettingsKeys.styles.CustomerBillsReport;

        let headerColumns = [
          {title: 'folio', span: 1, style: ['tableHeader'], rowStyle: ['firstItem'], columnWidth: 50},
          {title: 'cliente', span: 1, style: ['tableHeader'], rowStyle: [''], columnWidth: 180},
          {title: 'fecha', span: 1, style: ['tableHeader'], rowStyle: [''], columnWidth:90},
          {title: 'fecha_de_pago', span: 1, style: ['tableHeader'], rowStyle: [''], columnWidth: 90},
          {title: 'estatus', span: 1, style: ['tableHeader'], rowStyle: [''], columnWidth: 70},
          {title: 'total', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 85},
          {title: 'saldo', span: 1, style: ['tableHeader'], rowStyle: ['currencyFormat'], columnWidth: 85},
          {title: 'moneda', span: 1, style: ['tableHeader'], rowStyle: [''], columnWidth: 50},
        ];
        console.log(data);
          
        pdf.touchAbs({x:40,y:40}).img('http://www.iocsa.com.mx/img/main/logo_iocsa_big.png', 150).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().h1(PdfSettingsKeys.headers.CustomerBillsReport.title).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().h2(PdfSettingsKeys.headers.CustomerBillsReport.subtile).then(([index, cell]) => pdf.add(index, cell));
        pdf.touchAbs().table(data, headerColumns, true, true).then(([index, cell]) => pdf.add(index, cell));

        // console.log(data);
        
          // pdf.touchAbs().h3(cn).then(([index, cell]) => pdf.add(index, cell)); // Print Client Name
          // pdf.touchAbs().table(bodyData, headerColumns, false, true).then(([index, cell]) => pdf.add(index, cell)); // Print Data Table
          // pdf.touchAbs().table(sumData[cn], headerColumns, false, true).then(([index, cell]) => pdf.add(index, cell)); // Print Totals Sum Table
        


        // pdf.touchAbs().span('this.loremText').then(([index, cell]) => pdf.add(index, cell));
        // pdf.touchAbs().column(['this.loremText','this.loremText'], '*', 20 ).then(([index, cell]) => pdf.add(index, cell));

        pdf.open();
      },

    RemPdf: (rem: RemissionId) => {
      let pdf: Pdf = new Pdf({orientation: 'landscape', margins: 'l', pageSize: 'LETTER'});
      pdf.service.docDefinition.styles = <any> {...PdfSettingsKeys.generalStyles};
      pdf.touchAbs().h1(`Remisión ${rem.folio}`).then(([index, cell]) => pdf.add(index, cell));
      pdf.open();
      return pdf;
    }


  }
  
   
  }

  